import { SearchObject } from "app/common/Model/SearchObject";
import { exportSummaryOrderReport } from "app/services/InvoiceItemService";
import { pagingIinvoiceItemSummaryReport } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportInvoiceSummaryStore {
  listDataReportInvoiceSummary = null;
  searchInvoiceSummary = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    listDepId: null,
    treatmentCardIds: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchReportInvoiceSummary = (searchInvoiceSummary) => {
    this.searchInvoiceSummary = {
      ...this.searchInvoiceSummary,
      ...searchInvoiceSummary,
    };
    this.pagingReportReportInvoiceSummary();
  };

  pagingReportReportInvoiceSummary = async () => {
    let { listDepId, serviceId, treatmentCardIds, ...ortherData } =
      this.searchInvoiceSummary;
    
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!listDepId || listDepId.length === 0) {
      this.listDataReportInvoiceSummary = null;
      return;
    }
    
    if (listDepId) {
      ortherData.listDepId = listDepId?.map((el) => el?.id);
    } else {
      ortherData.listDepId = null;
    }
    if (serviceId) {
      ortherData.serviceId = serviceId?.id;
    }
    if (treatmentCardIds && Array.isArray(treatmentCardIds)) {
      ortherData.treatmentCardIds = treatmentCardIds.map((s) => s.id);
    } else if (treatmentCardIds) {
      ortherData.treatmentCardIds = [treatmentCardIds?.id];
    }
    return await pagingIinvoiceItemSummaryReport({ ...ortherData })
      .then(({ data }) => {
        this.listDataReportInvoiceSummary = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu đơn hàng tổng hợp có lỗi");
      });
  };

  handleExportReportInvoiceSummary = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = { ...this.normalizeSearchReportInvoiceSummary(searchObj) };

    try {
      const response = await exportSummaryOrderReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DON_HANG_TONG_HOP_TRUOC.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportInvoiceSummary = (rawSearch = {}) => {
    const { listDepId, treatmentCardIds, ...rest } = rawSearch;
    return {
      ...rest,
      listDepId: listDepId?.map((el) => el?.id),
      treatmentCardIds: treatmentCardIds?.map((el) => el?.id),
    };
  };
  resetStore = () => {
    this.listDataReportInvoiceSummary = null;
    this.searchInvoiceSummary = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      listDepId: null,
    };
  };
}
